import common from '../../link-editing/constants/common';

const TEXT_DECORATION_ATTRIBUTES = [
  'type',
  'border-radius',
  'thickness',
  'color',
  'padding-vertical',
  'padding-horizontal',
];

export const SUPPORTED_ATTRIBUTES = [
  'style',
  'src',
  'href',
  'alt',
  'rel',
  'target',
  'download',
  'content-position',
  'content-scale',
  'aspect-ratio',
  'class',
  common.LINK_CONFIG_ATTRIBUTE,
  ...TEXT_DECORATION_ATTRIBUTES,
];
